import { connect } from "react-redux";
import { updateNote } from "./NoteActions";
// import Note from './NoteContainer' ClassBase
import Note from "./NoteSection";

const mapDispatchToProps = (type) => (dispatch) => ({
  updateNote: (id, note) => dispatch(updateNote(id, note, type)),
});

export const VideoNote = connect(null, mapDispatchToProps("video"))(Note);
export const ProductNote = connect(null, mapDispatchToProps("product"))(Note);
export const InfluencerNote = connect(
  null,
  mapDispatchToProps("influencer")
)(Note);
